//React
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
//Sentry
import { configSentry } from "./utils/sentry";
//Styling
import "./App.css";
import "./reuseables.scss";
//Components
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import PickList from "./components/picklist/Picklist";
import IndvPickList from "./components/picklist/IndvPickList";
import OffLimits from "./components/auth/OffLimits";
import { WarehouseProtect } from "./components/auth/WarehouseProtect";
import QuickEdit from "./components/quickEdit/QuickEdit";
import ManualEDN from "./components/EDNs/ManualEDN";
import AdminPicklist from "./components/admin_picklist/Picklist";
import AdminIndvPickList from "./components/admin_picklist/AdminIndvPickList";
import AdminPickListSplit from "./components/admin_picklist/AdminPickListSplit";

configSentry();

function App() {
  return (
    <div className="App">
      <Router>
        <Nav />
        <Routes>
          <Route element={<WarehouseProtect />}>
            <Route path="/quick-edit" element={<QuickEdit />} />
            <Route path="/" element={<PickList />} />
            <Route path="/:id" element={<IndvPickList />} />
            <Route path="/manual-edn" element={<ManualEDN />} />
            <Route path="/admin-pick-list" element={<AdminPicklist />} />
            <Route path="/admin-pick-list/picklist-split/:id" element={<AdminPickListSplit />} />
            <Route
              path="/admin-pick-list/:id"
              element={<AdminIndvPickList />}
            />
          </Route>
          <Route path="/off-limits" element={<OffLimits />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
